import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Home/components/SectionVideo/SectionVideo.module.scss';

const cn = classNames.bind(styles);

const SectionVideo = (): ReactElement => {
  const { width } = useWindowSize();

  const renderVideoPlayer = (screenWidth: number) => {
    if (screenWidth > 767) {
      return (
        <div className={cn('video__player-box')}>
          <video
            className={cn('video__player')}
            poster="/images/pages/Home/poster.webp"
            controls
          >
            <source
              src="/video/pages/Home/presentation.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      );
    } else {
      return (
        <video
          className={cn('video__player')}
          poster="/images/pages/Home/poster.webp"
          controls
        >
          <source
            src="/video/pages/Home/presentation.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      );
    }
  };

  return (
    <section className={cn('video')}>
      <img
        className={cn('video__bg-clouds')}
        src="/images/pages/Home/video-background-clouds.svg"
        alt="cargoes-trade"
      />
      <div className={cn('container')}>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'VideoObject',
              name: 'Global Freight Network: International Freight Forwarding Service | DFA',
              description: 'International freight forwarding services. Become a member of DFA & join our freight network to access dynamic forwarders network & streamlined logistics.',
              thumbnailUrl: ['https://www.df-alliance.com/images/pages/Home/poster.webp'],
              uploadDate: '2025-10-02T08:00:00+08:00',
              duration: 'PT00H01M06S',
              contentUrl: 'https://www.df-alliance.com/video/pages/Home/presentation.mp4',
            }),
          }}
        />
        {renderVideoPlayer(width)}
      </div>
    </section>
  );
};

export default SectionVideo;